import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// TODO: Add actual social media links when provided by client
// TODO: Consider adding a newsletter signup section

const Footer = () => {
  const currentYear = new Date().getFullYear();

  console.log('[Footer] Rendering footer component');

  return (
    <footer className="footer mt-auto">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0">
            <div className="footer-brand">
              <img
                src="/assets/dd_logo_transparent.png"
                alt="DD Construction Logo"
                height="48"
                className="me-3"
              />
              <h5>DD Construction</h5>
            </div>
            <p className="footer-description mb-0">
              Professional residential construction services with over 25 years
              of experience. Building quality homes and lasting relationships.
            </p>
          </Col>
          <Col md={6}>
            <Row>
              <Col sm={6} className="mb-3 mb-sm-0">
                <div className="footer-links">
                  <h5>Quick Links</h5>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="mb-2">
                      <Link to="/gallery">Gallery</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col sm={6}>
                <div className="footer-links">
                  <h5>Contact</h5>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <a href="https://wa.me/+27824405441">
                        <i className="bi bi-whatsapp me-2"></i>
                        WhatsApp
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <hr />

        <Row>
          <Col className="text-center footer-bottom">
            <p className="mb-1">
              &copy; {currentYear} DD Construction. All rights reserved.
            </p>
            <p className="mb-0">
              Proudly Powered by{' '}
              <a
                href="https://www.cloudcafe.co.za"
                target="_blank"
                rel="noopener noreferrer"
              >
                CloudCafe (Pty) Ltd
              </a>
            </p>
            {/* CloudCafe Portfolio — cross-link to sister sites for SEO and brand visibility */}
            <p className="mb-0 mt-1">
              <small className="text-muted">
                Also by{' '}
                <a
                  href="https://www.cloudcafe.co.za"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CloudCafe
                </a>
                {' | '}
                <a
                  href="https://www.spitfirebraai.co.za"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SpitFire Braai Catering
                </a>
              </small>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
